var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0.11 0.74 17.77 17.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.04894 1.92705C8.3483 1.00574 9.6517 1.00574 9.95106 1.92705L11.2451 5.90983C11.379 6.32185 11.763 6.60081 12.1962 6.60081H16.3839C17.3527 6.60081 17.7554 7.84043 16.9717 8.40983L13.5838 10.8713C13.2333 11.126 13.0866 11.5773 13.2205 11.9894L14.5146 15.9721C14.8139 16.8934 13.7595 17.6596 12.9757 17.0902L9.58778 14.6287C9.2373 14.374 8.7627 14.374 8.41221 14.6287L5.02426 17.0902C4.24054 17.6596 3.18607 16.8934 3.48542 15.9721L4.7795 11.9894C4.91338 11.5773 4.76672 11.126 4.41623 10.8713L1.02827 8.40983C0.244561 7.84043 0.647338 6.60081 1.61606 6.60081H5.8038C6.23703 6.60081 6.62099 6.32185 6.75486 5.90983L8.04894 1.92705Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOutline);
export default __webpack_public_path__ + "static/media/star-outline.55792433a3b22d54177a30e9358b5d46.svg";
export { ForwardRef as ReactComponent };